export default "__VITE_ASSET__BVeMUP3f__"